module.exports = __webpack_public_path__ + "img/gridGallery3D.baa7eb6f.svg";